import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ErrorHandler, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { Router } from '@angular/router'
import { CodeCheckService } from '@lemon/core/service/code-check.service'
import { CurrencyService } from '@lemon/core/service/currency.service'
import { DateService } from '@lemon/core/service/date.service'
import { AsiakasService } from 'app/_angular/service/asiakas/asiakas.service'
import { VeroilmoitusEventsService } from 'app/_angular/service/veroilmoitus-events.service'
import { LadataanService } from 'app/_jaettu-angular/service/ladataan.service'
import { TallennaArvoBaseEvent } from 'app/_jaettu-lemonator/model/kirjanpito'
import { AsiakasJaettuService } from 'app/_jaettu-lemonator/service/asiakas-jaettu.service'
import { VeroilmoitusTranslationService } from 'app/_jaettu-lemonator/service/veroilmoitus/veroilmoitus-translation.service'
import { Observable } from 'rxjs'
import { VeroilmoituksenMuokkaustiedot } from '../veroilmoitus.component'

export interface KirjanpitoVeroilmoitusLomakeDialogData {
  veroilmoitusObservable: Observable<VeroilmoituksenMuokkaustiedot>
}
@Component({
  selector: '[app-lomake-62-dialog-2026]',
  templateUrl: './lomake-62-oy-2026.dialog.html',
  styleUrls: ['./lomake-rows.styles.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class Lomake62Oy2026Dialog implements OnInit, OnDestroy {
  veroilmoitusObservable: Observable<VeroilmoituksenMuokkaustiedot>

  constructor(
    @Inject(MAT_DIALOG_DATA) private _data: KirjanpitoVeroilmoitusLomakeDialogData,
    private _dialogRef: MatDialogRef<Lomake62Oy2026Dialog>,
    protected _router: Router,
    protected _asiakasService: AsiakasService,
    protected _currencyService: CurrencyService,
    protected _veroilmoitusTranslationService: VeroilmoitusTranslationService,
    protected _dateService: DateService,
    protected _changeDetector: ChangeDetectorRef,
    protected _asiakasJaettuService: AsiakasJaettuService,
    protected _codeCheckService: CodeCheckService,
    protected _dialog: MatDialog,
    protected _ladataanService: LadataanService,
    protected _errorHandler: ErrorHandler,
    protected _veroilmoitusEventsService: VeroilmoitusEventsService,
  ) {
    this.veroilmoitusObservable = _data.veroilmoitusObservable
  }

  ngOnInit() {}

  ngOnDestroy() {}

  lomakeMuuttui(event: TallennaArvoBaseEvent) {
    this._veroilmoitusEventsService.emit(event)
  }

  sulje() {
    this._dialogRef.close()
  }
}
